'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.yearsBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/yearsBefore.js
// module id = 401
// module chunks = 1